<template>
<el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div style="padding:50px 250px 50px 50px;" class="cs-fullHeight">  
            <div class="text-center backgroud-white cs-fullHeight main-content-container">  
                <div class="image-container">
                   <img src="../assets/warning.png">
                </div>
                <div class="content-container"> 
                    <span>请等待管理员审核</span>
                    <br/>
                    <span>如有需要请联系速成客服</span>
                </div>   
            </div>
        </div>
    </el-col> 
</el-row>
  
</template>

<style lang="scss" scoped>
    .main-content-container{
        padding-top:80px;
        .image-container {
            
        }
        .content-container{
            margin-top:20px;
        }
    }

</style>

<script>
import navigator from "../components/navigator";
export default {
  components: { navigator }
};

</script>
 



// WEBPACK FOOTER //
// src/page/reviewing.vue